export const MailJobTypeMapping: {[key: number]: string} = {
    0: "Onbekend",
    1: "Uitnodiging",
    2: "Voucher",
    3: "Shopping money herinnering",
    4: "Post herinnering",
}